import React from "react";

const FooterPadding: React.FC = () => {
  return <div style={{ padding: "34px" }} />;
};

export default FooterPadding;
